<template>
    <div>
        <HeaderPage></HeaderPage>
        <div class="content">
            <SlideShow></SlideShow>
        </div>
        <div>
            <h2>售后保障</h2>
            <div class="sales">
                <div>
                    <h3>定期巡检</h3>
                </div>
                <div style="width: 80%;">
                    <ul>
                        <li>公司专业维护人员每季度对设备进行例行维护</li>
                        <li>6.18、双11提前进行设备检修</li>
                    </ul>
                </div>
            </div>
            <div class="sales">
                <div>
                    <h3>驻点维护</h3>
                </div>
                <div style="width: 80%;">
                    <ul>
                        <li>公司在各片区设立维护中心，均有专职售后维护人员提供设备服务</li>
                        <li>售后维护承诺4-12小时内到达现场</li>
                    </ul>
                </div>
            </div>
            <div class="sales">
                <div>
                    <h3>快速响应</h3>
                </div>
                <div style="width: 80%;">
                    <ul>
                        <li>提供远程维护，30分钟内响应</li>
                        <li>7 * 24小时远程值守</li>
                    </ul>
                </div>
            </div>
        </div>

        <FooterPage></FooterPage>

    </div>
</template>

<script>
import HeaderPage from '@/components/HeaderPage.vue';
import SlideShow from '@/components/SlideShow.vue';
import FooterPage from '@/components/FooterPage.vue';

export default {
    name: 'SalesGuarantee',
    components: {
        HeaderPage,
        SlideShow,
        FooterPage
    },
}

</script>

<style scoped>
.content {
  width: 80%;
  margin: auto;
}
.sales {
    width: 70%;
    margin: auto;
    display: flex;
    justify-content: flex-start;  
    align-items: center;
    font-size: 18px;
    line-height: 30px;
}
.sales ul {
    width: 100%;
    background-color: #ffffff;
    padding: 30px;
    border-radius: 20px;
    margin-left: 50px;
}
.sales ul li {
    /* list-style: none; */
    text-align: left;
    margin-left: 50px;
}
</style>